// src/components/fancy/Marquee.jsx
"use client";
import React from "react";

export default function Marquee({ items = [], speed = 40, className = "" }) {
  const duration = `${Math.max(8, Math.min(40, 80 - speed))}s`; // map speed to duration
  
  // Duplicate items multiple times for seamless infinite scrolling
  const duplicatedItems = [...items, ...items, ...items, ...items];
  
  return (
    <div
      className={`relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)] ${className}`}
    >
      <div className="flex gap-8 animate-marquee will-change-transform whitespace-nowrap">
        {duplicatedItems.map((it, i) => (
          <span
            key={i}
            className="text-lg md:text-xl font-medium opacity-80 hover:opacity-100 transition
             text-gray-800 dark:text-gray-200"
          >
            {it}
          </span>
        ))}
      </div>
      <style jsx>{`
        .animate-marquee {
          animation: marquee ${duration} linear infinite;
        }
        @keyframes marquee {
          from {
            transform: translateX(0%);
          }
          to {
            transform: translateX(-25%);
          }
        }
      `}</style>
    </div>
  );
}
